import store from '../redux/store';

export default function getItemDetailFromCart(itemId) {
  const itemsArray = store.getState().cartReducer.items || [];
  const itemDetail = itemsArray?.filter((item) => item?.item_id === itemId);

  return itemDetail?.length ? itemDetail[0] : {};
}
